import { getAssetResources } from "../../repositories/WorkOrderResourcesRepository";
import { get } from "lodash-es";

type Props = {
	AssetId: number | null;
	setAssetAttachmentsList: Function;
	setIsLoadingResourcesList: (isLoading: boolean) => void;
	setErrorResourcesList: (err: string) => void;
	setAssetResourcesMessage: (showMessage: boolean) => void;
};

export const useSearchAssetResources = ({
	AssetId,
	setAssetAttachmentsList,
	setIsLoadingResourcesList,
	setErrorResourcesList,
	setAssetResourcesMessage,
}: Props) => {
	return async () => {
		setIsLoadingResourcesList(true);
		const res = await getAssetResources(AssetId as number);
		if (res.ok) {
			// Simplified: GetAssetResources now returns only attachments (single table)
			const assetAttachmentsList = get(res, "data.tables[0].rows", []);
			setAssetAttachmentsList(assetAttachmentsList);

			if (assetAttachmentsList.length === 0) {
				setAssetResourcesMessage(true);
			}

			setIsLoadingResourcesList(false);
		} else {
			setIsLoadingResourcesList(false);
			setErrorResourcesList(res.message);
		}
	};
};
